import { Box, Button, Grid2, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import { ReactComponent as PlayIcon } from "Assets/Icons/Home/PlayIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import Lecture from "./Lecture";
import Assignment from "./Assignment";

const styles = (theme) => ({
  "& .courseRoot": {
    marginTop: "10px",
  },
});

const BusinessCase = () => {
  const [currentTab, setCurrentTab] = useState(0);

  return (
    <Grid2 sx={styles}>
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Typography fontWeight={500} variant="subtitle">
          Business Case
        </Typography>
        <Button startIcon={<PrimaryIcon icon={PlayIcon} />} variant="contained">
          Time Management Strategies
        </Button>
      </Box>
      <Grid2 className="courseRoot">
        <Tabs
          type="button"
          value={currentTab}
          TabIndicatorProps={{ hidden: true }}
          onChange={(e, value) => setCurrentTab(value)}
        >
          <Tab label="Lecture" />
          <Tab label="Assignment" />
        </Tabs>
        {currentTab == "0" ? <Lecture /> : <Assignment />}
      </Grid2>
    </Grid2>
  );
};

export default BusinessCase;
